import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Close } from 'grommet-icons';
import Button from 'app/components/Button';

const Icon = styled(Close)`
  width: 48px;
  height: 48px;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`;

function CancelDeleteBookmarkButton({ AppState }) {
  return (
    <Button
      direction="row"
      pad="small"
      justify="center"
      align="center"
      fill="vertical"
      onClick={() => {
        AppState.prepareToDeleteBookmark([]);
        AppState.setMenuBar('BOOKMARKS_MENU');
      }}
    >
      <Icon size="large" color="accent-1" />
    </Button>
  );
}

export default inject('AppState')(observer(CancelDeleteBookmarkButton));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/CancelDeleteBookmarkButton.js